const FormResources = {

    form_data:{
        associate_id:                   '',
        supervisor_id:                  '',
        shift_id:                       '',
        group_id:                       '',
        cost_center_department_id:      '',
        number_assigment:               '',
        description:                    '',
        associate_pager:                '',
        supervisor_pager:               '',
        days_per_week:                  0,
        census:                         false,
        minutes:                        0,
        notes:                          '',
        avg_time_day:                   '',
        total_time:                     '',
        available_time:                 '',
        building_id:                    '',
        area_id:                        '',
        task_id:                        '',
        room_type_id:                   '',
        floor_id:                       '',
        cost_center_id:                 '',
        open:                           '',
        work_group:                     '',
        exclude_project:                '',
        exclude_daily:                  '',
        policing:                       '',
        project:                        '',
        patient:                        '',
        freq_simbol:                    '',
        frequency:                      '',
        shift1:                         false,
        shift2:                         false,
        shift3:                         false,
    },

    form_data_move: {
        current_daily_assignment_id: '',
        daily_assignment_id: '',
        rooms: []
    },

    form_data_note: {
        title: '',
        body_text: [],
        all_assignments: false,
        daily_assignment_id: [],
    },
    
    week_form_data: {
        sunday:     false,
        monday:     false,
        tuesday:    false,
        wednesday:  false,
        thursday:   false,
        friday:     false,
        saturday:   false,
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Assignment #:',
            model_name: 'number_assigment',
            ref:        'number_assigment_input',
            ref_alt:    'number_assigment_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Avg. Time/Day:',
            model_name: 'avg_time_day',
            ref:        'avg_time_day_input',
            ref_alt:    'avg_time_day_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Total Time:',
            model_name: 'total_time',
            ref:        'total_time_input',
            ref_alt:    'total_time_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_id',
            ref:        'supervisor_id_input',
            ref_alt:    'supervisor_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate pager:',
            model_name: 'associate_pager',
            ref:        'associate_pager_input',
            ref_alt:    'associate_pager_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Supervisor pager:',
            model_name: 'supervisor_pager',
            ref:        'supervisor_pager_input',
            ref_alt:    'supervisor_pager_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  7,
            disabled:   false,
            step:       'any',
            name:       'Days per week:',
            model_name: 'days_per_week',
            ref:        'days_per_week_input',
            ref_alt:    'days_per_week_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       'any',
            name:       'Available Minutes:',
            model_name: 'available_time',
            ref:        'available_time_input',
            ref_alt:    'available_time_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include in census:',
            model_name: 'census',
            ref:        'census_input',
            ref_alt:    'census_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Minutes/Discharge:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
    ],

    form_format_move:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Assigment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   true,
        },
    ],

    form_format_note:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Content:',
            model_name: 'body_text',
            ref:        'body_text_input',
            ref_alt:    'body_text_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'All Assignments:',
            model_name: 'all_assignments',
            ref:        'all_assignments_input',
            ref_alt:    'all_assignments_input_alt',
            required:   false,
        },
    ],

    shift_options:  [
        {
            id:     1,
            name:   'Day',
        },
        {
            id:     2,
            name:   'Evening',
        },
        {
            id:     3,
            name:   'Night',
        },
    ],

    days_per_weeks:  [
        {
            id:     0,
        },
        {
            id:     1,
        },
        {
            id:     2,
        },
        {
            id:     3,
        },
        {
            id:     4,
        },
        {
            id:     5,
        },
        {
            id:     6,
        },
        {
            id:     7,
        },
    ],

}

export default FormResources;